module.exports = __webpack_public_path__ + "static/img/7.449278c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangji/7.png
// module id = Bn1U
// module chunks = 1